const Loading: React.FC = () => {
    return (
        <div className="flex flex-col items-center justify-center h-full w-full bg-slate-950 text-sky-500 animate-fadeIn">
            <div className="w-10 h-10 border-4 border-slate-900 border-t-sky-500 rounded-full animate-spin mb-4"></div>
            {/* Minimal/Empty text as requested "dunkle leere Seite" - or just spinner */}
        </div>
    );
};

export default Loading;
